import React, { Fragment, useEffect } from "react";
import "./WhyJoinUs.css";
import "slick-carousel";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Slider from "react-slick";
import $ from "jquery";

function CareerGrowthPathways() {
  var settings = {
    slidesToShow: 1,
    slidesToScroll: 1,
    infinite: true,
    dots: false,
    arrows: true,
    adaptiveHeight: true,
  };
  //
  $.fn.dataImg = function (options) {
    var settings = $.extend(
      {
        sml: 400,

        med: 800,

        lrg: 1000,

        resize: false,
      },
      options,
    );

    var elements = $(this);

    function getSrc(element) {
      var screen = $(window).width();

      if (screen > settings.med) {
        return element.data("lrg");
      } else if (screen <= settings.med && screen > settings.sml) {
        return element.data("med");
      }

      return element.data("sml");
    }

    function breakpoints() {
      elements.each(function () {
        var e = $(this);

        var src = getSrc(e);

        if (src != undefined) {
          if (e.is("img")) {
            e.attr("src", src);
          } else {
            e.css("background-image", "url(" + src + ")");
          }
        }
      });
    }
    breakpoints();

    if (settings.resize === true) {
      $(window).resize(function () {
        breakpoints();
      });
    }
  };

  var plannerSliderSettings = {
    slidesToShow: 3,
    slidesToScroll: 1,
    infinite: true,
    dots: true,
    arrows: false,
    adaptiveHeight: true,
    responsive: [
      {
        breakpoint: 1025,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };

  //
  // $(document).ready(function () {
  // 	$(".header-mobile-menu").click(function () {
  // 		$(".nav-wrapper").toggleClass("show-menu");
  // 	});
  // });
  $(document).ready(function () {
    // $(".header-mobile-menu").click(function () {
    // 	$(".nav-wrapper").toggleClass("show-menu");
    // });

    setTimeout(function () {
      $(".academy2").css("display", "none");
      $(".academy3").css("display", "none");
      $(".academy4").css("display", "none");
      $(".academy5").css("display", "none");
      $(".academy6").css("display", "none");
      $(".academy7").css("display", "none");
      $(".academy8").css("display", "none");
      $(".academy9").css("display", "none");
    }, 1000);

    $(".academybtncntr li").click(function () {
      $(".academybtncntr li").removeClass("active");
      $(this).addClass("active");

      if ($("#academy1").hasClass("active")) {
        $(".facilitiesslider [class^=academy]").css("display", "none");
        $(".academy1").css("display", "block");
      }
      if ($("#academy2").hasClass("active")) {
        $(".facilitiesslider [class^=academy]").css("display", "none");
        $(".academy2").css("display", "block");
      }
      if ($("#academy3").hasClass("active")) {
        $(".facilitiesslider [class^=academy]").css("display", "none");
        $(".academy3").css("display", "block");
      }
      if ($("#academy4").hasClass("active")) {
        $(".facilitiesslider [class^=academy]").css("display", "none");
        $(".academy4").css("display", "block");
      }
      if ($("#academy5").hasClass("active")) {
        $(".facilitiesslider [class^=academy]").css("display", "none");
        $(".academy5").css("display", "block");
      }
      if ($("#academy6").hasClass("active")) {
        $(".facilitiesslider [class^=academy]").css("display", "none");
        $(".academy6").css("display", "block");
      }
      if ($("#academy7").hasClass("active")) {
        $(".facilitiesslider [class^=academy]").css("display", "none");
        $(".academy7").css("display", "block");
      }
      if ($("#academy8").hasClass("active")) {
        $(".facilitiesslider [class^=academy]").css("display", "none");
        $(".academy8").css("display", "block");
      }
      if ($("#academy9").hasClass("active")) {
        $(".facilitiesslider [class^=academy]").css("display", "none");
        $(".academy9").css("display", "block");
      }
    });
  });

  $(document).ready(function () {
    $(".facilities-view1").slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: true,
      fade: true,
      // //lazyLoad: "ondemand",
    });
  });

  $(document).ready(function () {
    $(".facilities-view2").slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: true,
      fade: true,
      //lazyLoad: "ondemand",
    });
  });

  $(document).ready(function () {
    $(".facilities-view3").slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: true,
      fade: true,
      //lazyLoad: "ondemand",
    });
  });

  $(document).ready(function () {
    $(".facilities-view4").slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: true,
      fade: true,
      //lazyLoad: "ondemand",
    });
  });

  $(document).ready(function () {
    $(".facilities-view5").slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: true,
      fade: true,
      //lazyLoad: "ondemand",
    });
  });

  $(document).ready(function () {
    $(".facilities-view6").slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: true,
      fade: true,
      //lazyLoad: "ondemand",
    });
  });

  $(document).ready(function () {
    $(".facilities-view7").slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: true,
      fade: true,
      //lazyLoad: "ondemand",
    });
  });

  $(document).ready(function () {
    $(".facilities-view8").slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: true,
      fade: true,
      //lazyLoad: "ondemand",
    });
  });

  $(document).ready(function () {
    $(".facilities-view9").slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: true,
      fade: true,
    });
  });

  return (
    <>
      <div className="main-container full_width why-join-us">
        <section className="section-masthead space-before-breadcrumb section-common-space masthead-mob-space overflow-hidden sectionnocolorbg  wju-section-1  my-0 py-0 section-container">
          <div className="container">
            <div className="row d-flex">
              <div className="col-lg-12">
                <nav aria-label="breadcrumb">
                  <ol className="breadcrumb">
                    <li className="breadcrumb-item">
                      <a href="/">Home</a>
                    </li>
                    <li className="breadcrumb-item d-none">
                      <a href="/work-at-jio-institute">Work at Jio Institute</a>
                    </li>
                    <li className="breadcrumb-item active" aria-current="page">
                      Career & Growth Pathways
                    </li>
                  </ol>
                </nav>
              </div>
            </div>
          </div>
        </section>

          <div className=" individual-who-wrapper layout layout--onecol sectionnocolorbg wju-section-3 section-container-3">
            <div className="layout__region layout__region--content">
              <div className="views-element-container container block block-views block-views-blockwork-with-us-block-1">
                <div className="content">
                  <div>
                    <div className="row view-inner-wrapper">
                      <div
                        className="view-header col-12 col-lg-6 col-xl-4"
                        data-aos="fade-right"
                      >
                        <h2 className="h2-02 font-black mb-2 heading-container-sm lh-1">
                          Career & Growth Pathways
                        </h2>
                        <p>
                          At Jio Institute, we offer diverse career
                          opportunities across academic and professional
                          domains.
                        </p>
                      </div>
                      <div
                        className="view-content row ol-12 col-lg-6 col-xl-8"
                        data-aos="fade-left"
                      >
                        <div className="views-row">
                          <h3>Faculty Careers</h3>
                          <div className="views-field views-field-field-slider-description">
                            <div className="field-content">
                              <p>
                                Shape future leaders through teaching, research,
                                and academic leadership. Engage in curriculum
                                design, interdisciplinary teaching, and
                                impactful research.
                              </p>
                            </div>
                          </div>
                        </div>
                        <div className="views-row">
                          <h3>Research Careers</h3>
                          <div className="views-field views-field-field-slider-description">
                            <div className="field-content">
                              <p>
                                Work on cutting-edge research across emerging
                                domains with access to institutional support,
                                funding, and global collaborations.
                              </p>
                            </div>
                          </div>
                        </div>
                        <div className="views-row">
                          <h3>Administrative and Professional Roles</h3>
                          <div className="views-field views-field-field-slider-description">
                            <div className="field-content">
                              <p>
                                Drive institutional excellence across HR,
                                operations, student engagement, strategy, and
                                more.
                              </p>
                            </div>
                          </div>
                        </div>
                        <div className="views-row">
                          <h3>Early Careers and Management Trainees</h3>
                          <div className="views-field views-field-field-slider-description">
                            <div className="field-content">
                              <p>
                                Our early career programs are designed to
                                nurture future leaders through structured
                                learning, cross-functional exposure, and
                                hands-on experience.
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
      </div>
    </>
  );
}

export default CareerGrowthPathways;
